import { Input, Tag, TagCloseButton, TagLabel, Flex } from "@chakra-ui/react";

interface TagInputProps {
  tags: string[];
  value: string;
  onChange: (value: string[]) => void;
  onSetValue: (value: string) => void;
}

const TagInput = ({
  tags,
  value,
  onChange: setTags,
  onSetValue: setValue,
}: TagInputProps) => {
  const handleKeyDown = (event: any) => {
    if ([",", "Enter"].includes(event.key)) {
      event.preventDefault();
      if (value && !tags.includes(value)) {
        setTags([...tags, value]);
        setValue("");
      }
    }
  };

  const handleRemoveTag = (tag: string) => {
    setTags(tags.filter((t) => t !== tag));
  };

  return (
    <>
      <Flex flexWrap="wrap">
        {tags.map((tag) => (
          <Tag
            key={tag}
            borderRadius="full"
            variant="ghost"
            colorScheme="blue"
            m="1"
          >
            <TagLabel>{tag}</TagLabel>
            <TagCloseButton onClick={() => handleRemoveTag(tag)} />
          </Tag>
        ))}
      </Flex>
      <Input
        placeholder="Separate words with commas"
        value={value}
        onKeyDown={handleKeyDown}
        onChange={(event) =>
          setValue(event.target.value?.toLowerCase()?.trim())
        }
        mt="2"
        focusBorderColor="second"
      />
    </>
  );
};

export default TagInput;
